export default __webpack_public_path__ + "static/media/Logo-3D-Black-Text-0100.3f99d23f.png";